import { render, staticRenderFns } from "./OnlineOrder.vue?vue&type=template&id=6ae03fc9&scoped=true&"
import script from "./OnlineOrder.vue?vue&type=script&lang=js&"
export * from "./OnlineOrder.vue?vue&type=script&lang=js&"
import style0 from "./OnlineOrder.vue?vue&type=style&index=0&id=6ae03fc9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae03fc9",
  null
  
)

export default component.exports